import { render, staticRenderFns } from "./BaseSinglePie.vue?vue&type=template&id=a1673194&scoped=true"
import script from "./BaseSinglePie.vue?vue&type=script&lang=js"
export * from "./BaseSinglePie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1673194",
  null
  
)

export default component.exports